import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { useLanguage } from './components/utils/translations';

const SEOUpdater = () => {
  const { language } = useLanguage();
  useEffect(() => {
    const metaDescription = document.querySelector('meta[name="description"]');
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (language === 'fr') {
      if (metaDescription) metaDescription.setAttribute('content', 'Convertissez, modifiez et gérez facilement vos fichiers PDF. Les meilleurs outils PDF pour vos besoins quotidiens.');
      if (metaKeywords) metaKeywords.setAttribute('content', 'PDF, outils PDF, convertir PDF, éditer PDF, fusionner PDF, diviser PDF, PDF en Word, PDF en Excel, PDF en JPG, PDF en PNG, PDF en PPT, PDF en TXT, PDF en JSON, PDF en CSV, PDF en GIF, PDF en RTF, PDF en PPTX, PDF en DOCX, image en PDF, JPG en PDF, PNG en PDF, outils PDF gratuits, convertisseur PDF en ligne');
    } else {
      if (metaDescription) metaDescription.setAttribute('content', 'Easily convert, edit, and manage your PDF files. The best PDF tools for your daily needs.');
      if (metaKeywords) metaKeywords.setAttribute('content', 'PDF, PDF tools, convert PDF, edit PDF, merge PDF, split PDF, PDF to Word, PDF to Excel, PDF to JPG, PDF to PNG, PDF to PPT, PDF to TXT, PDF to JSON, PDF to CSV, PDF to GIF, PDF to RTF, PDF to PPTX, PDF to DOCX, image to PDF, JPG to PDF, PNG to PDF, free PDF tools, online PDF converter');
    }
  }, [language]);
  return null;
};

const AppWithProviders = () => {
  return (
    <>
      <SEOUpdater />
      <App />
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <AppWithProviders />
    </Router>
  </React.StrictMode>
);

reportWebVitals();
